import React, { createContext, useContext } from 'react';

export type StatAccessMode = 'staff' | 'parent';

const StatAccessModeContext = createContext<StatAccessMode>('staff');

export function StatAccessModeProvider({
  mode,
  children,
}: {
  mode: StatAccessMode;
  children: React.ReactNode;
}) {
  return <StatAccessModeContext.Provider value={mode}>{children}</StatAccessModeContext.Provider>;
}

export function useStatAccessMode(): StatAccessMode {
  return useContext(StatAccessModeContext);
}
